import { Dispatch } from 'redux';
import { WalkieTalkieActions } from '../Redux/WalkieTalkie/WalkieTalkieAction';
import audioUtil from './AudioService';

/**
 * Classe per gestire il timer di timeout del canale walkie-talkie
 */
class WalkieTalkieTimerManager {
  private timerId: number | null = null;
  private duration: number = 30000; // Default 30 secondi in millisecondi

  /**
   * Avvia il timer di timeout
   * @param dispatch Redux dispatch function
   * @param sentinelId ID del letto attivo
   * @param durationMs Durata in millisecondi (opzionale)
   */
  start(dispatch: Dispatch, sentinelId: number, durationMs?: number): void {
    // Ferma timer precedente se esiste
    this.stop();

    // Usa durata custom o quella di default
    const duration = durationMs || this.duration;

    console.log(`⏱️ WalkieTalkieTimer: Avvio timer ${duration / 1000}s per sentinel ${sentinelId}`);

    // Avvia nuovo timer
    this.timerId = window.setTimeout(() => {
      console.log(`⏰ WalkieTalkieTimer: Timeout scaduto per sentinel ${sentinelId}`);
      
      // Spegne canale audio
      audioUtil.closeDeviceMic(sentinelId);
      audioUtil.disableAudioStream(sentinelId);
      
      // Dispatch azione timeout
      dispatch(WalkieTalkieActions.channelTimeout());
      
      this.timerId = null;
    }, duration);

    // Salva timer handle nello stato Redux
    dispatch(WalkieTalkieActions.startChannelTimer(this.timerId));
  }

  /**
   * Resetta il timer (riavvia da capo)
   * @param dispatch Redux dispatch function
   * @param sentinelId ID del letto attivo
   * @param durationMs Durata in millisecondi (opzionale)
   */
  reset(dispatch: Dispatch, sentinelId: number, durationMs?: number): void {
    console.log(`🔄 WalkieTalkieTimer: Reset timer per sentinel ${sentinelId}`);
    
    // Dispatch azione reset (aggiorna timestamp)
    dispatch(WalkieTalkieActions.resetChannelTimer());
    
    // Riavvia timer
    this.start(dispatch, sentinelId, durationMs);
  }

  /**
   * Ferma il timer
   */
  stop(): void {
    if (this.timerId !== null) {
      console.log(`⏹️ WalkieTalkieTimer: Stop timer ${this.timerId}`);
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  /**
   * Imposta la durata di default del timer
   * @param durationMs Durata in millisecondi
   */
  setDefaultDuration(durationMs: number): void {
    this.duration = durationMs;
  }

  /**
   * Ottiene la durata di default del timer
   */
  getDefaultDuration(): number {
    return this.duration;
  }

  /**
   * Verifica se il timer è attivo
   */
  isActive(): boolean {
    return this.timerId !== null;
  }

  /**
   * Ottiene l'ID del timer corrente
   */
  getTimerId(): number | null {
    return this.timerId;
  }
}


// Esporta istanza singleton
const walkieTalkieTimer = new WalkieTalkieTimerManager();
export default walkieTalkieTimer;
